"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Cell = function Cell(props) {
  var data = props.data,
      header = props.header,
      headerText = props.headerText,
      handleClick = props.handleClick,
      highlighted = props.highlighted,
      width = props.width,
      sortable = props.sortable,
      sortOrder = props.sortOrder;
  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    onClick: handleClick,
    width: width,
    fontSize: 0,
    sortable: sortable,
    sortOrder: sortOrder
  }, headerText) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    highlighted: highlighted,
    width: width,
    fontSize: 2
  }, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    pr: "32px"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouter.Link, {
    to: data.to
  }, data.text)));
};

var _default = Cell;
exports["default"] = _default;

//# sourceMappingURL=CellLink.js.map